import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Activity } from "lucide-react";

import styles from "./workstream-tracking-page.module.css";

export function ProjectActivityAction({ active, onClick }: { active: boolean; onClick: () => void }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEffect(() => { setTarget(document.getElementById("page-header-actions")); }, []);
  if (!target) return null;
  return createPortal(
    <button type="button" className={`${styles.projectActivityTrigger} ${active ? styles.projectActivityTriggerActive : ""}`} onClick={onClick} aria-pressed={active}>
      <Activity /><span>Activity</span>
    </button>,
    target,
  );
}
